export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ScrollButton.vue?vue&type=template&id=06289b8e&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ScrollButton.vue?vue&type=template&id=06289b8e&scoped=true
// module id = 128
// module chunks = 0